import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import { VirtualRoomRouterStoreSelectors } from '@era/stores';
import * as fromAlarm from './alarm.reducer';

export interface AlarmState {
  alarms: fromAlarm.AlarmState;
}

export const reducers: ActionReducerMap<AlarmState> = {
  alarms: fromAlarm.alarmReducer,
};

export const selectAlarmState = createFeatureSelector<fromAlarm.AlarmState>(fromAlarm.inRoomAlarmFeatureKey);

export const selectAlarmIds = createSelector(selectAlarmState, fromAlarm.selectAlarmIds);

export const selectAlarmEntities = createSelector(selectAlarmState, fromAlarm.selectAlarmEntities);

export const selectAllAlarms = createSelector(selectAlarmState, fromAlarm.selectAllAlarms);

export const getAlarmForRoom = (location: string, room: string) =>
  createSelector(
    selectAlarmState,
    fromAlarm.selectAlarmEntities,
    (state) => state.entities[fromAlarm.selectAlarmId(location, room)]
  );

export const selectCurrentAlarm = createSelector(
  selectAlarmEntities,
  VirtualRoomRouterStoreSelectors.selectLocation,
  VirtualRoomRouterStoreSelectors.selectRoom,
  (entities, location: string, room: string) => {
    return entities[fromAlarm.selectAlarmId(location, room)];
  }
);
